// ⚠️ FICHIER GÉNÉRÉ — ne pas éditer ici. Source : shared/ui/ · régénérer avec `bash shared/sync.sh`
'use client';
// Verrou de défilement du document pendant qu'une modale est ouverte.
//
// Constat d'Inès (17/08, mobile) : le doigt qui fait défiler une modale
// entraîne la PAGE derrière elle — le formulaire de demande d'accès devient
// inatteignable, le bouton d'envoi reste hors écran. `overflow: hidden` posé
// sur <body> ne suffit pas : iOS Safari continue de faire défiler le document
// au toucher. La technique fiable est de FIGER le body (`position: fixed`) en
// mémorisant la position, puis de la restaurer au déverrouillage — c'est le
// `top` négatif qui préserve l'endroit exact où la personne se trouvait.
//
// Un seul verrou à la fois par document : un compteur évite qu'une modale
// imbriquée (avis ouvert par-dessus la connexion) ne restaure trop tôt.
import { useEffect } from 'react';

let profondeur = 0;
let positionFigee = 0;

export function useVerrouScroll(actif: boolean): void {
  useEffect(() => {
    if (!actif) return;
    profondeur += 1;
    if (profondeur === 1) {
      positionFigee = window.scrollY;
      const b = document.body.style;
      b.position = 'fixed';
      b.top = `-${positionFigee}px`;
      b.insetInlineStart = '0';
      b.width = '100%';
      b.overflowY = 'scroll'; // conserve la gouttière : la page ne « saute » pas en largeur
    }
    return () => {
      profondeur -= 1;
      if (profondeur === 0) {
        const b = document.body.style;
        b.position = '';
        b.top = '';
        b.insetInlineStart = '';
        b.width = '';
        b.overflowY = '';
        window.scrollTo(0, positionFigee);
      }
    };
  }, [actif]);
}
